import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  base: "/",
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "author" */ "./views/Page.vue")
    },
    {
      path: "/search/:slug",
      name: "search",
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/Search.vue")
    },
    {
      path: "/recettes/:slug",
      name: "recipe",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "recipe" */ "./views/RecipeSingle.vue")
    },
    {
      path: "/recettes",
      name: "recettes",
      component: () =>
        import(/* webpackChunkName: "recipes" */ "./views/RecipeArchive.vue")
    },
    {
      path: "/categories/:slug",
      name: "category",
      component: () =>
        import(/* webpackChunkName: "category" */ "./views/Category.vue")
    },
    {
      path: "/categories/:slug/:subcat",
      name: "subcategory",
      component: () =>
        import(/* webpackChunkName: "category" */ "./views/Category.vue")
    },
    {
      path: "/categories/:slug/page/:page",
      name: "categoryPaged",
      component: () =>
        import(/* webpackChunkName: "category" */ "./views/Category.vue")
    },
    {
      path: "/cuisto/:slug",
      name: "author",
      component: () =>
        import(/* webpackChunkName: "author" */ "./views/AuthorSingle.vue")
    },
    {
      path: "/login",
      name: "login",
      props: { register: false },
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/LoginRegister.vue")
    },
    {
      path: "/login/1",
      name: "login-verify-true",
      props: { register: false, verification: true, verificationSuccess: true },
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/LoginRegister.vue")
    },
    {
      path: "/login/0",
      name: "login-verify-false",
      props: {
        register: false,
        verification: true,
        verificationSuccess: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/LoginRegister.vue")
    },
    {
      path: "/register",
      name: "register",
      props: { register: true },
      component: () =>
        import(/* webpackChunkName: "register" */ "./views/LoginRegister.vue")
    },
    {
      path: "/compte",
      name: "account",
      component: () =>
        import(/* webpackChunkName: "account" */ "./views/account/Account.vue")
    },
    {
      path: "/compte/favoris",
      name: "favorites",
      component: () =>
        import(
          /* webpackChunkName: "favorites" */ "./views/account/Account.vue"
        )
    },
    {
      path: "/styleguide",
      name: "styleguide",
      component: () =>
        import(/* webpackChunkName: "author" */ "./views/Styleguide.vue")
    },
    {
      // IMPORTANT: Need to be last item
      path: "/:slug",
      name: "page",
      component: () => import(/* webpackChunkName: "page" */ "./views/Page.vue")
    }
  ]
});
